export default __webpack_public_path__ + "static/media/k.f6017529.wav";